import { Heading, View, Link } from '@adobe/react-spectrum';
import styles from '../../../../styles.module.scss';
import { Paper, TableHead, TableRow, Table, TableBody, Checkbox } from '@mui/material';
import { FeesStatus, header, paymentData } from '../constant';
import { CustomTableContainer as TableContainer, CustomTableCell as TableCell } from '../../../../CommonComponent/CustomTableItems';

const PaymentList = () => {
  return (
    <View UNSAFE_className={styles.card} marginTop="size-100">
      <Heading marginTop="size-0" level={4}>
        Payment List
      </Heading>
      <View height="100%" overflow="auto">
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: '100%',
            overflowY: 'auto',
          }}
        >
          <Table stickyHeader sx={{ minWidth: header.length * 150 }}>
            <TableHead>
              <TableRow>
                {header.map((item, idx) => (
                  <TableCell key={idx} sx={{ backgroundColor: '#fff', fontWeight: 'bold' }} align="center">
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paymentData.map((row, key) => (
                <TableRow key={key}>
                  <TableCell align="center">{row.admissionId}</TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">
                    {row.class} {row.section}
                  </TableCell>
                  <TableCell align="center">
                    {row.month}-{row.year}
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={row.feesStatus === FeesStatus.PAID || row.feesStatus === FeesStatus.INPROCESS}
                      disabled={row.feesStatus === FeesStatus.PAID}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {row.feesReciept && row.feesReciept.length > 0
                      ? row.feesReciept.map((link, idx) => (
                          <Link key={idx} href={link} target="_blank" isQuiet>
                            Receipt {idx + 1}
                          </Link>
                        ))
                      : 'N/A'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </View>
    </View>
  );
};

export default PaymentList;
